var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',[_vm._v(" API IP address: "+_vm._s(_vm.ip)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }